import { useState } from "react";
import QuestionModalAnswer from "./QuestionModalAnswer";
import useAxios from "../../MainComponents/Hooks/useAxios";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "../../MainComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faCircleCheck,
  faCircleXmark,
  faSpinner,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import HelmetTags from "../../MainComponents/HelmetTags";

const ModalAnswer = ({ previousHomework, exam }) => {
  const [collapse, setCollapse] = useState(false);
  const [activeQuestionId, setActiveQuestionId] = useState(0);
  const [showPopUpVideo, setShowPopUpVideo] = useState(false);
  const [currentVideoSrc, setCurrentVideoSrc] = useState("");
  const { contentID, ID } = useParams();
  const navigate = useNavigate();

  const api = previousHomework
    ? process.env.REACT_APP_STUDENT_QUIZZ_PREVIOUS_QUESTIONS_MODAL_ANSWER_API
    : exam
    ? process.env.REACT_APP_STUDENT_TRIAL_EXAM_MODAL_ANSWER_API
    : process.env.REACT_APP_STUDENT_QUIZZ_HOMEWORK_MODAL_ANSWER_API;

  const [modalAnswerData, modalAnswerErrors, modalAnswerLoading] = useAxios(
    `${api}/${contentID ? contentID : ID}`,
    "GET",
    "GET",
    ""
  );

  function handleOnClickQuestion(id) {
    handelOpenCollapse();
    setActiveQuestionId(id);
  }

  function handelOpenCollapse() {
    setCollapse(true);
  }

  function handelCloseCollapse() {
    setCollapse(false);
  }

  return (
    <div className="left-response-container flex items-start md:w-full">
      <HelmetTags title="Modal Answer | Mr.Mohamed Salama"></HelmetTags>
      <QuestionModalAnswer
        collapse={collapse}
        onCloseCollapse={handelCloseCollapse}
        activeQuestionId={activeQuestionId}
        question={modalAnswerData?.data[activeQuestionId]}
        setCurrentVideoSrc={setCurrentVideoSrc}
        setShowPopUpVideo={setShowPopUpVideo}
      />
      <div className="all-questions flex h-full flex-col items-center overflow-y-auto  bg-light p-[40px] text-light transition-all  duration-300 ease-in-out w-full md:order-2 md:w-full">
        {modalAnswerLoading && <Loader />}
        {modalAnswerErrors && (
          <div className="flex justify-center flex-col">
            <p>{modalAnswerErrors}</p>
            <button
              onClick={() => navigate(-1)}
              className="flex justify-center my-6"
            >
              <div className="collapse-btn top-[96px] flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-full bg-green text-light shadow-md shadow-black/40 duration-300 hover:scale-110 hover:text-light">
                <FontAwesomeIcon
                  className={`transition-all duration-300 ease-in-out hover:scale-110`}
                  icon={faChevronRight}
                />
              </div>
            </button>
          </div>
        )}
        {!modalAnswerLoading && !modalAnswerErrors && (
          <>
            <h1 className="text-[20px] font-bold text-secondary ">
              Modal Answer
            </h1>
            <p className="my-[20px] text-center text-secondary">
              Click on the question number to see its answer
            </p>

            <div className="response-questions myactual-questions-container my-[40px] w-1/2">
              {modalAnswerData?.data?.map((question, index) => (
                <div
                  key={index}
                  onClick={() => handleOnClickQuestion(index)}
                  className={`single-ques-square  mb-[4px] flex h-[44px] w-[44px] cursor-pointer items-center justify-center rounded-md text-[18px] font-bold text-[#fff] ${
                    question.is_correct ? "bg-lime-500" : "bg-secondary"
                  }  `}
                >
                  {index + 1}
                </div>
              ))}
            </div>
            <div className="indicators flex w-full items-center justify-center gap-[20px] border-t-2 border-t-light py-[20px] sm:flex-col">
              <div className="correct flex items-center gap-[8px] justify-self-center text-[18px] text-lime-500">
                <FontAwesomeIcon icon={faCircleCheck} />
                <p>Correct Answer</p>
              </div>
              <div className="correct flex items-center gap-[8px] justify-self-center text-[18px] text-secondary">
                <FontAwesomeIcon icon={faCircleXmark} /> <p>Wrong Answer</p>
              </div>
              <div className="correct flex items-center gap-[8px] justify-self-center text-[18px] text-amber-400">
                <FontAwesomeIcon icon={faSpinner} spinPulse />{" "}
                <p>Waiting For Correction</p>
              </div>
            </div>
          </>
        )}
      </div>
      <div
        onClick={() => setShowPopUpVideo(false)}
        className={`popup__video fixed inset-0 z-50 w-full h-screen flex transition-all duration-300 ease-in-out origin-bottom flex-col items-end justify-center gap-3 bg-blue/20 ${
          showPopUpVideo
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          onClick={() => setShowPopUpVideo(false)}
          className="close-question-btn  flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-full  bg-delete text-bg text-light shadow-md shadow-delete/40 transition-all duration-300 ease-in-out hover:scale-110 active:scale-90 mr-5"
        >
          <FontAwesomeIcon
            className={`  hover:scale-110 active:scale-90 `}
            icon={faXmark}
          />
        </div>
        <div
          className={`w-full h-fit transition-all origin-bottom duration-300 ease-linear flex justify-center items-center ${
            showPopUpVideo ? "scale-100" : "scale-0"
          }`}
        >
          <div className="question__video w-3/4 aspect-video  overflow-hidden rounded-xl border-2">
            <iframe
              src={currentVideoSrc}
              width="100%"
              height="100%"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; fullscreen; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    // <></>
  );
};

export default ModalAnswer;
